import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCookie, removeAppCookies, removeSingleCookie } from '../../utils/cookies-util';
import { BASE_PATH } from '../../constants/admin-paths';
import { userType } from '../../utils';
import { USER_BASE_PATH } from '../../constants/user-paths';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { removePatientUser } from '../../reducers/patient-user-slice';
import { setUserConfirmation } from '../../reducers/user-dashboard-slice';
import { persistor } from 'store';

const AuthRoute = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [allow, setAllow] = useState(false);
  const { id } = useSelector((store) => store.patientUserData?.data);
  const validToken = userType() === 'user' ? getCookie('access-token-user') : getCookie('access-token');
  const params = new URLSearchParams(window.location.search);
  const user_id = params.get('user_id');
  const error = params.get('error');
  const message = params.get('message');

  useEffect(() => {
    if (user_id) {
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);

      if (user_id == id && validToken) {
        removeSingleCookie('resend-time');
        dispatch(setUserConfirmation({ confirmation_sent_at: null, confirmed_at: true }));
        navigate(userType() === 'user' ? USER_BASE_PATH : BASE_PATH, { replace: true });
      } else {
        removeAppCookies(true);
        persistor.purge();
        dispatch(removePatientUser());
        setAllow(true);
      }
      if (error) toast.error(error || 'Unable to login');
      if (message) toast.success(message || '');
    } else if (!!validToken) {
      navigate(userType() === 'user' ? USER_BASE_PATH : BASE_PATH, { replace: true });
    }
    if (!validToken) {
      setAllow(true);
    }
  }, [user_id, validToken]);

  return allow ? children : null;
};

export default AuthRoute;
